import React, { Component }  from "react";
import {Card, Form, Button, Row, Col, Alert} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import { getCurrentUser, validaSenha} from '../../common/utils';
import withReactContent from 'sweetalert2-react-content'
import { withRouter } from '../../common/with-router';
import { FaRegEdit, FaTrash, FaEye, FaEyeSlash } from "react-icons/fa";
import AsyncSelect from 'react-select/async';
import { useEffect } from "react";

class UsuariosEdit extends Component {
    constructor(props) {
        super(props);
        this.onChangeFirstName = this.onChangeFirstName.bind(this);
        this.onChangeLastName = this.onChangeLastName.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangeUsername = this.onChangeUsername.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
        this.onChangeConfPassword = this.onChangeConfPassword.bind(this);
        this.onChangeIsActive = this.onChangeIsActive.bind(this);
        this.onChangeIsStaff = this.onChangeIsStaff.bind(this);
        this.onChangeIsSuperUser = this.onChangeIsSuperUser.bind(this);
        this.enviaUsuario = this.enviaUsuario.bind(this);

        this.state = {
            first_name: "",
            last_name: "",
            email: "",
            username: "",
            password: "",
            conf_password: "",
            is_active: true,
            is_staff: false,
            is_superuser: false,
            firstNameHelper: "",
            lastNameHelper: "",
            emailHelper: "",
            usernameHelper: "",
            passwordHelper: "",
            confPasswordHelper: "",
            erroLoadUser: "",
            user_id: "",
            titulo_pagina: "",
            loading: false,
            permissoes: "",
            tpVinculo: "Nenhum",
            idVinculo: "",
            nomeVinculo: "",
            idVinculado: "",
            mfa: "",
            senha: '',
            senha_confirma: '',
            mostrarSenha: { senha: false, senhaConfirma: false },
            requisitosSenha: {
                tamanho: false,
                minuscula: false,
                maiuscula: false,
                numero: false,
                especial: false
            },
        };
    } 

    componentDidMount(){
        const id = this.props.router.params.id;

        const dados_usuario = getCurrentUser();
        
        if(!dados_usuario.is_superuser) {
            window.location.href = '/sem-permissao';
            return;
        }

        if(id){
            this.setState({
                user_id: id,
                titulo_pagina: 'Editando Usuário',
                loading: true,
                erroLoadUser: ''
            })

            //consulta os dados do usuario na api
            api.get(`/usuarios/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadUser: '',
                    first_name: dados.first_name,
                    last_name: dados.last_name,
                    email: dados.email,
                    username: dados.username,
                    is_active: dados.is_active,
                    is_staff: dados.is_staff,
                    is_superuser: dados.is_superuser,
                    mfa: dados.mfa,
                    loading: false
                });

                //permissoes
                this.setState({
                    permissoes: dados.permissoes_list.map(this.mapResponseToValuesAndLabels)
                });

                //grupos
                this.setState({
                    grupos: dados.grupos_list.map(this.mapResponseToValuesAndLabels)
                });
                this.getVinculo(id);
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar usuário, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadUser: erro_msg,
                })
            });
        }
        else {
            this.setState({
                user_id: '',
                titulo_pagina: 'Adicionar Usuário',
                loading: false,
                erroLoadUser: '',
            })
        }
    }    

    

    enviaUsuario = (e) => {
        e.preventDefault();        

        if (this.state.alterar_senha && this.state.senha) {
            if (!validaSenha(this.state.senha)) {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'error',
                    title: 'Senha Fraca',
                    text: 'Sua senha deve ter mais de 8 caracteres, incluir pelo menos uma letra maiúscula, uma letra minúscula, um número e um caractere especial.',
                    showCloseButton: true,
                });
                return;
            }
    
            if (this.state.alterar_senha && this.state.senha !== this.state.senha_confirma) {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'As senhas não coincidem.',
                    showCloseButton: true,
                });
                return; // Para interromper a execução se houver erro
            }
        }

        this.setState({
            loading: true,
            firstNameHelper: '',
            lastNameHelper: '',
            emailHelper: '',
            usernameHelper: '',
            passwordHelper: '',
            confPasswordHelper: '',
        });

        //verifica se é edição ou adição
        const url = (this.state.user_id) ? '/usuarios/'+this.state.user_id+'/' : '/usuarios/'
        const metodo = (this.state.user_id) ? 'put' : 'post'

        //valida confirmacao de senha
        if(!this.state.user_id && this.state.password !== this.state.conf_password){
            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>Erro ao confirmar a senha, verifique os campos de senha</p>,
            })    
            
            this.setState({
                loading: false,
                confPasswordHelper: 'A confirmação de senha está incorreta'
            })

            return false;
        }

        //permissoes
        let perm_list = [];
        for (let key in this.state.permissoes){
            const perm = this.state.permissoes[key]
            perm_list.push(perm.value)
        }

        //grupos
        let grupos_list = [];
        for (let key in this.state.grupos){
            const grupo = this.state.grupos[key]
            grupos_list.push(grupo.value)
        }

        let dados_payload = {
            'first_name': this.state.first_name,
            'last_name': this.state.last_name,
            'email': this.state.email,
            'username': this.state.username,            
            'is_active': (this.state.is_active) ? true : false,
            'is_staff': (this.state.is_staff) ? true : false,
            'is_superuser': (this.state.is_superuser) ? true : false,
            'permissoes': perm_list,
            'grupos': grupos_list,
        }

        if(!this.state.user_id){
            dados_payload['password'] = this.state.password;
        }

        if(this.state.alterar_senha){
            dados_payload['password'] = this.state.senha;
        }
        
        //envia para api
        api({
            method: metodo,
            url: url,
            data: dados_payload
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.user_id) ? 'Usuário atualizado com sucesso' : 'Usuário cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            //redireciona
            if(!this.state.user_id){
                if(this.state.idVinculo){
                    if(!this.state.nomeVinculo){
                        this.enviaVinculo(e, response.data.id, "POST")
                    }
                } else {
                    this.props.router.navigate("/usuarios");
                }                
            } else {
                if(!this.state.nomeVinculo){
                    this.enviaVinculo(e, this.state.user_id, "POST");
                }
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar usuário, verifique os campos e tente novamente';            
            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'first_name'){
                        this.setState({
                            firstNameHelper: value,
                        })
                    }
                    if(key === 'last_name'){
                        this.setState({
                            lastNameHelper: value,
                        })
                    }
                    if(key === 'email'){
                        this.setState({
                            emailHelper: value,
                        })
                    }
                    if(key === 'username'){
                        this.setState({
                            usernameHelper: value,
                        })
                    }
                    if(key === 'password'){
                        this.setState({
                            passwordHelper: value,
                        })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    excluirMfa = (e) => {
        e.preventDefault();

        const MySwal = withReactContent(Swal)

        MySwal.fire({
            title: 'Deseja realmente excluir o 2FA?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({
                    loading: true,
                });
                 
                //envia para api
                api({
                    method: 'PUT',
                    url: '/usuarios/2fa/qrcode/'+this.state.user_id+'/',
                    data: {
                        'excluir': true,
                    }
                })
                .then(response => {
                    const MySwal = withReactContent(Swal)

                    MySwal.fire({
                        title: <p>2FA excluído com sucesso</p>,
                        icon: 'success',
                        showCloseButton: true,
                    })
                    
                    this.setState({
                        loading: false,
                        mfa: "",
                    })
                })
                .catch(error => {
                    MySwal.fire({
                        icon: 'error',
                        showCloseButton: true,
                        title: <p>Erro ao excluir o 2FA, tente novamente mais tarde</p>,
                    })    
                    
                    this.setState({
                        loading: false,
                    })
                });
            }
        })        
    }

    gerarQrCode = (e) => {
        e.preventDefault();

        const MySwal = withReactContent(Swal)

        MySwal.fire({
            title: 'Deseja realmente continuar?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({
                    loading: true,
                });
                 
                //envia para api
                api({
                    method: 'PUT',
                    url: '/usuarios/2fa/qrcode/'+this.state.user_id+'/',
                })
                .then(response => {
                    const data = response.data;
                    const MySwal = withReactContent(Swal)

                    MySwal.fire({
                        title: <p>Qrcode gerado com sucesso</p>,
                        icon: 'success',
                        showCloseButton: true,
                    })
                    
                    this.setState({
                        loading: false,
                        mfa: {
                            qrcode: data.qrcode,
                            secret: data.secret,
                        },
                    })
                })
                .catch(error => {
                    MySwal.fire({
                        icon: 'error',
                        showCloseButton: true,
                        title: <p>Erro ao gerar o qrcode, tente novamente mais tarde</p>,
                    })    
                    
                    this.setState({
                        loading: false,
                    })
                });
            }
        })        
    };

    onChangeFirstName = (e) => {            
        this.setState({
            first_name: e.target.value,
        })
    };

    onChangeLastName = (e) => {   
        this.setState({
            last_name: e.target.value,
        })
    };

    onChangeEmail = (e) => {   
        this.setState({
            email: e.target.value,
        })
    };

    onChangeUsername = (e) => {   
        this.setState({
            username: e.target.value,
        })
    };

    onChangePassword = (e) => {   
        this.setState({
            password: e.target.value,
        })
    };

    onChangeConfPassword = (e) => {   
        this.setState({
            conf_password: e.target.value,
        })
    };

    onChangeIsActive = (e) => {   
        this.setState({
            is_active: e.target.checked,
        })
    };

    onChangeIsStaff = (e) => {           
        this.setState({
            is_staff: e.target.checked,
        })
    };

    onChangeIsSuperUser = (e) => {           
        this.setState({
            is_superuser: e.target.checked,
        })
    };

    mapResponseToValuesAndLabels = (data) => ({
        value: data.id,
        label: data.name,
    });

    handleChange = (event, fieldName) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    toggleSenhaVisibilidade = campo => {
        this.setState(prevState => ({
            mostrarSenha: { ...prevState.mostrarSenha, [campo]: !prevState.mostrarSenha[campo] }
        }));
    }

    verificaRequisitosSenha = (senha) => {
        const requisitos = {
            tamanho: senha.length > 8,
            minuscula: /[a-z]/.test(senha),
            maiuscula: /[A-Z]/.test(senha),
            numero: /[0-9]/.test(senha),
            especial: /[$@#&!]/.test(senha)
        };
        this.setState({ requisitosSenha: requisitos });
    }

    buscaUserPermissoes = async (busca) => {        
        try {
            const {data:response} = await api.get(`/permissoes/?busca=${busca}`)
            const results = response.results;

            return results.map(this.mapResponseToValuesAndLabels)
        }
          
        catch (error) {
            console.log(error);
            
            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>Erro ao consultar permissões, tente novamente</p>,
            })  
        }
    }

    buscaGrupoPermissoes = async (busca) => {        
        try {
            const {data:response} = await api.get(`/grupos/?busca=${busca}`)
            const results = response.results;

            return results.map(this.mapResponseToValuesAndLabels)
        }
          
        catch (error) {
            console.log(error);
            
            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>Erro ao consultar grupos, tente novamente</p>,
            })  
        }
    }

    buscaVinculoGestor = async (busca) => {
        try {
            const {data:response} = await api.get(`/pessoas/gestores/?nome=${busca}`)
            const results = response.results;
            console.log(results);
            return results.map(this.mapResponseVinculo)
        }
          
        catch (error) {
            console.log(error);
        }
    }

    buscaVinculoNavegador = async (busca) => {
        try {
            const {data:response} = await api.get(`/pessoas/operadores/?nome=${busca}`)
            const results = response.results;

            return results.map(this.mapResponseVinculo)
        }
          
        catch (error) {
            console.log(error);
        }
    }

    buscaVinculoPrestador = async (busca) => {    
        try {
            const {data:response} = await api.get(`/pessoas/prestadores/?nome=${busca}`)
            const results = response.results;

            return results.map(this.mapResponseVinculo)
        }
          
        catch (error) {
            console.log(error);
        }
    }

    mapResponseVinculo = (data) => {
        if(this.state.tpVinculo == "prestador"){
            return {value: data.id, label: data.nome + " (CPF/CNPJ: "+ data.cpf_cnpj +") Categoria: "+ data.categoria}
        } else {
            return {value: data.id,label: data.dados_pessoa.nome}    
        }
        
    };

    altTpVinculo = (e) => {
        this.setState({
            tpVinculo: e.target.value,
            idVinculo: ""
        })
    }

    getVinculo = (id) => {
        
        api.get("/usuarios/restricoes/?user_id="+id)
        .then(response => {
            const dados = response.data;
            console.log(dados.results[0]);
            //preenche os inputs
            this.setState({
                tpVinculo: dados.results[0].tipo_usuario,
                idVinculado: dados.results[0].id
            });

            if(dados.results[0].tipo_usuario == "prestador"){
                this.setState({
                    idVinculo: dados.results[0].prestador_id,
                    nomeVinculo: dados.results[0].dados_prestador.nome

                });    
            }
            if(dados.results[0].tipo_usuario == "operador"){ 
                this.setState({
                    idVinculo: dados.results[0].operador_id,
                    nomeVinculo: dados.results[0].dados_operador.nome
                });    
            }

            if(dados.results[0].tipo_usuario == "gestor"){
                this.setState({
                    idVinculo: dados.results[0].gestor_id,
                    nomeVinculo: dados.results[0].dados_gestor.nome,
                });    
            }
        })
        .catch(error => {
            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento, tente novamente';
            }

            this.setState({
                erroLoadUser: erro_msg,
            })
        });
    }

    enviaVinculo = (e, id, metodo) => {
        e.preventDefault();
        //Endpoint referente a HNS-138 (Vincula usuário)
        //envia para api
        const url = (metodo == "POST") ? '/usuarios/restricoes/' : `/usuarios/restricoes/${id}`;
        let dadosVinculo = {
            'user_id': id,
            'tipo_usuario': this.state.tpVinculo
        }
        
        if (this.state.tpVinculo == "prestador") {
            dadosVinculo = {
                ...dadosVinculo,
                'prestador_id': this.state.idVinculo
            };
        }
        
        if (this.state.tpVinculo == "operador") {
            dadosVinculo = {
                ...dadosVinculo,
                'operador_id': this.state.idVinculo
            };
        }
        
        if (this.state.tpVinculo == "gestor") {
            dadosVinculo = {
                ...dadosVinculo,
                'gestor_id': this.state.idVinculo
            };
        }

        api({
            method: metodo,
            url: url,
            data: dadosVinculo
        })
        .then(response => {

            this.setState({
                loading: false,
            })
        
            //redireciona
            if(this.state.user_id){
                this.getVinculo(this.state.user_id);
                //this.props.router.navigate("/usuarios");
            } else {
                this.props.router.navigate("/usuarios");    
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar usuário, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                erro_msg = 'Erro ao vincular usuario';
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })

        });
        if(metodo != "POST"){
            this.setState({
                tpVinculo: "",
                idVinculo: "",
                idVinculado: "",
                nomeVinculo: ""
            })    
        }
    }

    render(){
        const dados_usuario = getCurrentUser();
        
        if(!dados_usuario.is_superuser) {
            return;
        }
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Form method="get" onSubmit={this.enviaUsuario}>
                    <Card className="cardDestaque">
                        <Card.Body>                                            
                            <Row>
                                <Col sm={4} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Check type="switch" name="is_active" id="is_active" label="Ativo" value="1" checked={this.state.is_active ? true : false} onChange={this.onChangeIsActive} />
                                    </Form.Group>
                                </Col>
                                <Col sm={4} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Check type="switch" name="is_staff" id="is_staff" label="Funcionário" value="1" checked={this.state.is_staff ? true : false} onChange={this.onChangeIsStaff} />
                                    </Form.Group>
                                </Col>
                                <Col sm={4} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Check type="switch" name="is_superuser" id="is_superuser" label="Super usuário" value="1" checked={this.state.is_superuser ? true : false} onChange={this.onChangeIsSuperUser} />
                                    </Form.Group>
                                </Col>
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control type="text" required placeholder="Nome" name="first_name" id="first_name" value={this.state.first_name} onChange={this.onChangeFirstName} />                            
                                        <Form.Text id="formFirstNameHelpBlock" className="text-danger">{this.state.firstNameHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Sobrenome</Form.Label>
                                        <Form.Control type="text" required placeholder="Sobrenome" name="last_name" id="last_name" value={this.state.last_name} onChange={this.onChangeLastName} />                            
                                        <Form.Text id="formLastNameHelpBlock" className="text-danger">{this.state.lastNameHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control type="email" required placeholder="E-mail" name="email" id="formEmail" value={this.state.email} onChange={this.onChangeEmail} />                            
                                        <Form.Text id="formEmailHelpBlock" className="text-danger">{this.state.emailHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Username</Form.Label>
                                        <Form.Control type="text" required placeholder="Username" name="username" id="username" value={this.state.username} onChange={this.onChangeUsername} />                            
                                        <Form.Text id="formUsernameHelpBlock" className="text-danger">{this.state.usernameHelper}</Form.Text>
                                    </Form.Group>
                                </Col>                                
                                {!this.state.user_id &&
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Senha</Form.Label>
                                        <Form.Control type="password" required placeholder="Senha" name="password" id="password" onChange={this.onChangePassword} />                            
                                        <Form.Text id="formPasswordHelpBlock" className="text-danger">{this.state.passwordHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                                }
                                {!this.state.user_id &&
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Confirmação de senha</Form.Label>
                                        <Form.Control type="password" required placeholder="Confirmação de senha" name="conf_password" id="conf_password" onChange={this.onChangeConfPassword} />                            
                                        <Form.Text id="formConfPasswordHelpBlock" className="text-danger">{this.state.confPasswordHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                                }
                            </Row> 
                            
                            {this.state.erroLoadUser ? 
                            <Alert variant="warning">
                                {this.state.erroLoadUser}
                            </Alert> : ''
                            }                                                                                     
                        </Card.Body>                
                    </Card>

                    <Card className="cardDestaque mt-3">
                        <Card.Body>      
                            <h4>Permissões</h4>                                      
                            <Row>
                                <Col xs={12}>
                                    <Form.Group className="mb-3">
                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={this.buscaUserPermissoes}
                                            onChange={(data) => {
                                                this.setState({
                                                    permissoes: data
                                                });
                                            }}
                                            value={this.state.permissoes}
                                            isMulti
                                            defaultOptions
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>

                    <Card className="cardDestaque mt-3">
                        <Card.Body>      
                            <h4>Vincular usuário</h4>    
                            {this.state.nomeVinculo && ( 
                                <Row>
                                    <Col xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Select className="form-control" aria-readonly>
                                                <option selected>{this.state.nomeVinculo}</option>
                                            </Form.Select>
                                            <Button style={{ marginTop: "10px" }} type="button" variant="secondary" onClick={(e) => this.enviaVinculo(e, this.state.idVinculado, "DELETE")}>Deletar vínculo</Button>
                                        </Form.Group>
                                    </Col>
                                    
                                </Row>     
                            )}
                            {!this.state.nomeVinculo && (                                  
                            <Row>
                                <Col xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Select className="form-control" name="tpVinculo" onChange={this.altTpVinculo}>
                                            <option value="Nenhum" selected>Nenhum</option>
                                            <option value="prestador">Prestador</option>
                                            <option value="operador">Navegador</option>
                                            <option value="gestor">Gestor</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            )}
                            {this.state.tpVinculo != "Nenhum" && !this.state.nomeVinculo && (
                            <Row>
                                <Col xs={12}>
                                    {this.state.tpVinculo == "prestador" && (
                                        <AsyncSelect
                                            
                                            loadOptions={this.buscaVinculoPrestador}
                                            onChange={(data) => {
                                                this.setState({
                                                    idVinculo: data.value
                                                });
                                            }}
                                            
                                            defaultOptions
                                        />
                                    )}
                                    {this.state.tpVinculo == "operador" && (
                                        <AsyncSelect
                                            
                                            loadOptions={this.buscaVinculoNavegador}
                                            onChange={(data) => {
                                                this.setState({
                                                    idVinculo: data.value
                                                });
                                            }}
                                            
                                            defaultOptions
                                        />
                                    )}
                                    {this.state.tpVinculo == "gestor" && (
                                        <AsyncSelect
                                            
                                            loadOptions={this.buscaVinculoGestor}
                                            onChange={(data) => {
                                                this.setState({
                                                    idVinculo: data.value
                                                });
                                            }}
                                            
                                            defaultOptions
                                        />
                                    )}
                                </Col>
                            </Row>
                            )}
                        </Card.Body>
                    </Card>

                    <Card className="cardDestaque mt-3">
                        <Card.Body>      
                            <h4>Grupos</h4>                                      
                            <Row>
                                <Col xs={12}>
                                    <Form.Group className="mb-3">
                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={this.buscaGrupoPermissoes}
                                            onChange={(data) => {
                                                this.setState({
                                                    grupos: data
                                                });
                                            }}
                                            value={this.state.grupos}
                                            isMulti
                                            defaultOptions
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>

                    <Card className="cardDestaque mt-3">
                        <Card.Body>      
                            <h4>2FA</h4>                                      
                            <Row>
                                <Col xs={12}>                                    
                                    {
                                    this.state.mfa && 
                                        <img src={this.state.mfa.qrcode} alt="Qrcode" style={{width: '200px'}} />
                                    }                                    
                                    <div>
                                        {!this.state.mfa && (
                                            <Button type="button" variant="secondary" onClick={this.gerarQrCode}>Gerar Qrcode</Button>
                                        )}
                                        {this.state.mfa && (
                                            <Button type="button" variant="warning" onClick={this.excluirMfa} style={{marginLeft: '10px'}}>Excluir 2FA</Button>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    {dados_usuario['is_superuser'] && this.state.user_id && (
                        <Card className="cardDestaque mt-3">
                            <Card.Body>
                                <h4 className="mt-3">Dados de Acesso</h4>
                                    <Row>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Alterar senha?</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.alterar_senha ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ alterar_senha: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.alterar_senha ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ alterar_senha: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {this.state.alterar_senha && (
                                        <Row>                                        
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3 position-relative">
                                                    <Form.Label>Senha <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type={this.state.mostrarSenha.senha ? "text" : "password"}
                                                        name="senha"
                                                        placeholder="Senha"
                                                        value={this.state.senha}
                                                        onChange={this.handleChange}
                                                    />
                                                    <i
                                                        onClick={() => this.toggleSenhaVisibilidade('senha')}
                                                        className="senha-icon"
                                                        style={{ position: 'absolute', right: '10px', top: '38px', cursor: 'pointer' }}
                                                    >
                                                        {this.state.mostrarSenha.senha ? <FaEyeSlash /> : <FaEye />}
                                                    </i>
                                                </Form.Group>
                                                <p className="mb-0">Requisitos da senha: </p>
                                                <ul>
                                                    <li style={{ color: this.state.requisitosSenha.tamanho ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.tamanho ? '700' : '400' }}>
                                                        Quantidade de caracteres maior que 8 {this.state.requisitosSenha.tamanho && <FaCheck />}
                                                    </li>
                                                    <li style={{ color: this.state.requisitosSenha.minuscula ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.minuscula ? '700' : '400' }}>
                                                        Uma letra minuscula {this.state.requisitosSenha.minuscula && <FaCheck />}
                                                    </li>
                                                    <li style={{ color: this.state.requisitosSenha.maiuscula ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.maiuscula ? '700' : '400' }}>
                                                        Uma letra maiuscula {this.state.requisitosSenha.maiuscula && <FaCheck />}
                                                    </li>
                                                    <li style={{ color: this.state.requisitosSenha.numero ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.numero ? '700' : '400' }}>
                                                        Um número de 0 a 9 {this.state.requisitosSenha.numero && <FaCheck />}
                                                    </li>
                                                    <li style={{ color: this.state.requisitosSenha.especial ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.especial ? '700' : '400' }}>
                                                        Pelo menos um dos seguintes caracteres $@#&! {this.state.requisitosSenha.especial && <FaCheck />}
                                                    </li>
                                                </ul>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3 position-relative">
                                                    <Form.Label>Confirmar Senha <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type={this.state.mostrarSenha.senhaConfirma ? "text" : "password"}
                                                        name="senha_confirma"
                                                        placeholder="Confirmar Senha"
                                                        value={this.state.senha_confirma}
                                                        onChange={this.handleChange}
                                                    />
                                                    <i
                                                        onClick={() => this.toggleSenhaVisibilidade('senhaConfirma')}
                                                        className="senha-icon"
                                                        style={{ position: 'absolute', right: '10px', top: '38px', cursor: 'pointer' }}
                                                    >
                                                        {this.state.mostrarSenha.senhaConfirma ? <FaEyeSlash /> : <FaEye />}
                                                    </i>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    )}
                            </Card.Body>
                        </Card>
                    )} 
                    <div className="text-center">
                        <Button type="submit" className="btn btn-first mt-3" disabled={this.state.loading}>
                            {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Salvar'}                                       
                        </Button>     
                    </div>
                </Form> 
            </div>
        )
    }
}

export default withRouter(UsuariosEdit);